export default () => {
  const orderStatus = document.getElementById('order_status');
  
  if (orderStatus) {
    orderStatus.addEventListener('change', e => {
      console.log('changed!');
      e.target.form.submit();
    });
  }
};